module.exports = __webpack_public_path__ + "img/impulse_thumbnail_mobile.3575412c.jpg";